import { format, getMonth } from 'date-fns';
import * as React from 'react';

const DatePill: React.FunctionComponent<{ date: Date }> = ({ date }) => (
  <>
    <h4 className="f3 display fw8 tc mt0 mb2" data-testid={format(date, 'YYYY-MM-DD')}>
      {/* Don't put a period after the May */}
      {getMonth(date) === 4 ? format(date, 'MMM D') : format(date, 'MMM. D')}
    </h4>
    <div className="w2 bb b--navy center" />
    <div className="center h1 bg-navy" style={{ width: 1 }} />
  </>
);

export default DatePill;
